import React from 'react';
import { Empty } from 'antd';
import { SharedSHSSummaryReport } from './templates/SharedSHSSummaryReport';
import { resolveSHSConfig } from './reportConfigResolver';

export function SHSSummaryReport(props) {
   const config = resolveSHSConfig(props.template, props.subject_id);

   if (!config) {
      return <Empty description='Report not yet available.' image="../images/brainee_mascot.png" />;
   }

   return <SharedSHSSummaryReport {...props} config={config} />;
}
